import { createHttpService } from "@nebula/http";
import { AxiosStatic } from "axios";
import { useToast } from "nebula-mobile";
import { sdkService } from "@/service/sdk";
import qs from "qs";
const http = createHttpService({
  init(axiosStatic: AxiosStatic) {
    axiosStatic.defaults.baseURL = import.meta.env.VITE_HTTP_API;

    // 请求全局请求拦截处理
    axiosStatic.interceptors.request.use(
      (config) => {
        const sdkOptions = sdkService.options;
        const { method } = config;
        const preParams = {
          app_id: sdkOptions.app_id,
          open_id: sdkOptions.open_id,
          sign: sdkOptions.sign,
          company_id: sdkOptions.company_id,
          language: sdkOptions.language,
          source: sdkOptions.source,
          token: sdkOptions.token,
        };

        if (method === "get") {
          config.params = { ...preParams, ...config.params };
          return config;
        }

        config.data = qs.stringify({
          ...preParams,
          ...qs.parse(config.data),
        });
        return config;
      },
      (error) => {
        // 错误处理统一格式
        return Promise.resolve({
          result: false,
          status: "fail",
          code: -1,
          msg: "请求异常，稍后重试",
          data: error,
        });
      }
    );

    // 请求全局响应拦截处理
    axiosStatic.interceptors.response.use(
      ({ data }) => {
        const result = data.status === "success" && data.code === 1000;
        return { ...data, result };
      },
      (error) => {
        // 错误处理统一格式
        return Promise.resolve({
          result: false,
          status: "fail",
          code: -1,
          msg: "请求异常，稍后重试",
          data: error,
        });
      }
    );
  },
  error({ message }, { msg, data }) {
    if (process.env.NODE_ENV === "development") {
      console.error(msg, data);
    }

    if (!msg || message === false) return;
    const taost = useToast();
    taost.info({
      content: msg,
    });
  },
  success({ message }, { msg }) {
    if (!msg || message !== true) return;
    const taost = useToast();
    taost.success({
      content: msg,
    });
  },
});

export const httpService = http;
